import { type ModuleData, ModuleProvider, useModule } from '#providers'
import { ConsentDto } from '../../types/authenticateSmartcheckSessionDto'

interface ClientConsentConfig {
	clientName: string
}

interface ClientConsentData {
	consents: ConsentDto[]
}

type ConsentRequest = {
	id: string
	isAccepted: boolean
	isOptional: boolean
}

export type ClientConsentModuleData = ModuleData<
	ClientConsentData,
	ConsentRequest[],
	ClientConsentConfig
>

export const ClientConsentModuleProvider: typeof ModuleProvider<ClientConsentModuleData> =
	ModuleProvider

export const useClientConsentModule: typeof useModule<ClientConsentModuleData> =
	useModule
